module.exports = __webpack_public_path__ + "static/media/favicon.88025b4d.ico";